import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  standalone: true,
  imports: [NgOptimizedImage],
})
export class LoginErrorComponent {
  readonly error = input<string>();
  readonly cause = input<string>();
}
